var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPasswordIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#passwordIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.041 6.873c1.09 2.025 3.35 3.416 5.959 3.416 2.61 0 4.87-1.391 5.96-3.416M5.24 8.428 2.72 10.54m5.506-.464L7.013 13.13m7.747-4.702 2.52 2.111m-5.51-.464 1.212 3.055",
  stroke: "#4F52C3",
  strokeWidth: 1.45,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "passwordIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(2 2.001)",
  d: "M0 0h16v16H0z"
})))));
export default SvgPasswordIcon;